import React from 'react';
import styles from './PreviewTabs.module.css';
type TProps = {
  tabs: string[];
  selected: number;
  setSelected: React.Dispatch<React.SetStateAction<number>>;
};
const PreviewTabs = ({ tabs, selected, setSelected }: TProps) => {
  const yellowBackgroundColor = styles.yellowBackground;

  return (
    <div className={styles.supportTabsDiv}>
      {tabs.map((tab, index) => (
        <div
          key={index}
          className={[
            styles.supportTab,
            'font-poppins text-xs',
            index === selected && yellowBackgroundColor,
          ].join(' ')}
          onClick={() => {
            setSelected(index);
          }}
        >
          {tab}
        </div>
      ))}
    </div>
  );
};

export default PreviewTabs;
